var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9895 14.2696L4.72534 21.5338C4.40047 21.8586 4.03129 22.0137 3.6178 21.999C3.2043 21.9844 2.83512 21.8146 2.51026 21.4897C2.18539 21.1649 2.02296 20.7884 2.02296 20.3602C2.02296 19.932 2.18539 19.5555 2.51026 19.2306L9.73038 12.0105L2.46624 4.74639C2.14138 4.42153 1.98628 4.04501 2.00095 3.61685C2.01562 3.18868 2.18539 2.81217 2.51026 2.4873C2.83512 2.16243 3.21164 2 3.6398 2C4.06797 2 4.44449 2.16243 4.76935 2.4873L11.9895 9.75143L19.2541 2.4873C19.5786 2.16243 19.955 2 20.3832 2C20.8116 2 21.1881 2.16243 21.5127 2.4873C21.8376 2.81217 22 3.18868 22 3.61685C22 4.04501 21.8376 4.42153 21.5127 4.74639L14.2486 12.0105L21.5127 19.2751C21.8376 19.5997 22 19.9687 22 20.3822C22 20.7957 21.8376 21.1649 21.5127 21.4897C21.1881 21.8146 20.8116 21.977 20.3832 21.977C19.955 21.977 19.5786 21.8146 19.2541 21.4897L11.9895 14.2696Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0a8ac8ddd259d393f5cf95c708cb01bf.svg";
export { ForwardRef as ReactComponent };